import React, { useCallback, useEffect, useState } from 'react';
import MainLayout from 'src/components/layouts/MainLayout';
import styles from 'src/styles/layout.module.css';
import { Breadcrumb, Button, Form, Input, Row, Space, Spin, Typography } from 'antd';
import { Link, useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { UserOutlined } from '@ant-design/icons';
import tileStyles from 'src/styles/tile.module.css';

import { useForm } from 'antd/es/form/Form';
import { AppDispatch } from 'src/index';
import { useLanguagesState, useLanguagesValues } from 'src/features/languages/languages.hooks';
import { createLanguage, fetchLanguages } from 'src/features/languages/languages.state';
import { Language } from 'src/features/languages/languages.types';

const emptyLanguage: Language = { code: '', name: '' };

const LanguagesPage: React.FC = () => {
  const dispatch: AppDispatch = useDispatch();
  const languages = useLanguagesValues();
  const history = useHistory();

  const [form] = useForm();

  const [createMode, setCreateMode] = useState<boolean>(false);
  const [newEntity, setNewEntity] = useState<Language>(emptyLanguage);

  const handleCreateButtonClick = useCallback(() => {
    setCreateMode(true);
  }, []);

  const handleFormSubmit = useCallback(async () => {
    const response = await dispatch(createLanguage(newEntity));

    if (createLanguage.fulfilled.match(response)) {
      history.push(`/settings/languages/${response.payload.code}`);
    }
  }, [dispatch, history, newEntity]);

  return (
    <MainLayout>
      <div className={styles.mainGrid}>
        <div className={styles.breadCrumbs}>
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to='/settings/languages'>
                <Space>
                  <UserOutlined />
                  Языки
                </Space>
              </Link>
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <div className={styles.contentArea}>
          <Typography.Title level={2} className={styles.title}>
            Языки
          </Typography.Title>
          <div>
            {createMode && (
              <Form
                form={form}
                validateTrigger='onBlur'
                layout='vertical'
                className={tileStyles.listTile}
                onFinish={handleFormSubmit}
              >
                <UserOutlined />
                <Form.Item name='code' rules={[{ required: true }]} noStyle>
                  <Input
                    type='text'
                    name='code'
                    placeholder='Введите код языка'
                    style={{ width: '35%' }}
                    onChange={ev => setNewEntity(e => ({ ...e, code: ev.target.value }))}
                  />
                </Form.Item>
                <Form.Item name='name' rules={[{ required: true }]} noStyle>
                  <Input
                    type='text'
                    name='name'
                    placeholder='Введите название языка'
                    style={{ width: '35%' }}
                    onChange={ev => setNewEntity(e => ({ ...e, name: ev.target.value }))}
                  />
                </Form.Item>
                <Button htmlType='button' type='default' onClick={() => setCreateMode(false)}>
                  Отменить
                </Button>
                <Button htmlType='submit' type='primary' disabled={newEntity.name === '' || newEntity.code === ''}>
                  Создать
                </Button>
              </Form>
            )}
            {languages.map(c => (
              <div key={c.code} className={tileStyles.listTile}>
                <Link to={`/settings/languages/${c.code}`} className={tileStyles.tileName}>
                  <Space>
                    <UserOutlined />
                    <span>
                      {c.name} ({c.code})
                    </span>
                  </Space>
                </Link>
              </div>
            ))}
          </div>
        </div>
        <div className={styles.sidebar}>
          <Space>
            <Button type='primary' onClick={handleCreateButtonClick}>
              Создать новый язык
            </Button>
          </Space>
        </div>
      </div>
    </MainLayout>
  );
};

const LanguagesPageBlock: React.FC = () => {
  const dispatch = useDispatch();
  const languagesState = useLanguagesState();

  useEffect(() => {
    dispatch(fetchLanguages({}));
  }, [dispatch]);

  if (languagesState.isPending) {
    return (
      <MainLayout>
        <Row align={'middle'} justify={'center'} style={{ minHeight: '100vh' }}>
          <Spin size={'large'} />
        </Row>
      </MainLayout>
    );
  }

  return <LanguagesPage />;
};

export default LanguagesPageBlock;
